<template>
    <div class="filters-sidebar">
        <!-- Búsqueda -->
        <q-card class="q-mb-md search-card">
            <q-card-section>
                <q-input v-model="search" @update:model-value="$emit('update:filter', $event)" outlined dense
                    debounce="500" placeholder="Buscar productos..." clearable>
                    <template v-slot:prepend>
                        <q-icon name="search" />
                    </template>
                </q-input>

            </q-card-section>
            <q-inner-loading :showing="loading">
                <q-spinner-dots size="30" color="primary" />
            </q-inner-loading>
        </q-card>

        <!-- Filtros -->
        <q-card class="filter-card">
            <q-card-section class="row items-center justify-between">
                <span class="text-h6">Filtros</span>
                <q-btn v-if="activeFiltersCount > 0" flat dense size="sm" color="primary" label="Limpiar" icon="clear"
                    @click="$emit('clear-filters')" />
            </q-card-section>

            <q-separator />

            <q-card-section class="q-col-gutter-md">
                <GltnCheckProductoTipo v-model="productosFiltro" @update:model-value="$emit('update:filter', $event)"
                    multiple emit-value map-options use-chips label="Tipo de Producto" />

                <template v-if="esFiltroPanel">
                    <q-select v-model="filtro.tipo" @update:model-value="updateFiltro('tipo', $event)" outlined
                        use-chips dense multiple :options="variables.tipo" label="Tipo de panel" />

                    <q-select v-model="filtro.densidad" @update:model-value="updateFiltro('densidad', $event)" outlined
                        use-chips multiple dense :options="variables.densidad" label="Densidad" />

                    <q-select v-model="filtro.nucleo" @update:model-value="updateFiltro('nucleo', $event)" outlined
                        use-chips multiple dense :options="variables.nucleo" label="Núcleo" />

                    <q-select v-model="filtro.espesor" @update:model-value="updateFiltro('espesor', $event)" outlined
                        use-chips multiple dense :options="variables.espesorPanel" label="Espesor" />

                    <q-expansion-item label="Cara externa" icon="layers" default-opened>
                        <div class="q-pa-md q-gutter-md">
                            <q-select v-model="filtro.extRev" @update:model-value="updateFiltro('extRev', $event)"
                                outlined use-chips multiple dense :options="variables.revestimiento"
                                label="Revestimiento" />

                            <q-select v-model="filtro.extCol" @update:model-value="updateFiltro('extCol', $event)"
                                outlined use-chips multiple dense :options="variables.color" label="Color" />

                            <q-select v-model="filtro.extEsp" @update:model-value="updateFiltro('extEsp', $event)"
                                outlined use-chips multiple dense :options="variables.espesorCara" label="Espesor" />

                            <q-select v-model="filtro.extTerm" @update:model-value="updateFiltro('extTerm', $event)"
                                outlined use-chips multiple dense :options="variables.terminacion"
                                label="Terminacion" />
                        </div>
                    </q-expansion-item>

                    <q-expansion-item label="Cara Interna" icon="layers">
                        <div class="q-pa-md q-gutter-md">
                            <q-select v-model="filtro.intRev" @update:model-value="updateFiltro('intRev', $event)"
                                outlined use-chips multiple dense :options="variables.revestimiento"
                                label="Revestimiento" />

                            <q-select v-model="filtro.intCol" @update:model-value="updateFiltro('intCol', $event)"
                                outlined use-chips multiple dense :options="variables.color" label="Color" />

                            <q-select v-model="filtro.intEsp" @update:model-value="updateFiltro('intEsp', $event)"
                                outlined use-chips multiple dense :options="variables.espesorCara" label="Espesor" />

                            <q-select v-model="filtro.intTerm" @update:model-value="updateFiltro('intTerm', $event)"
                                outlined use-chips multiple dense :options="variables.terminacion"
                                label="Terminacion" />
                        </div>
                    </q-expansion-item>
                </template>
            </q-card-section>
            <q-inner-loading :showing="loading">
                <q-spinner-dots size="30" color="primary" />
            </q-inner-loading>
        </q-card>
    </div>
</template>

<script setup>
import GltnCheckProductoTipo from "@/components/form/GltnCheckProductoTipo.vue";
const filtro = defineModel('filtro');
const search = defineModel('search');
const productosFiltro = defineModel('productosFiltro');
defineProps({
    variables: Object,
    esFiltroPanel: Boolean,
    activeFiltersCount: Number,
    loading: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits([
    'update:search',
    'update:productosFiltro',
    'update:filter',
    'clear-filters'
]);

const updateFiltro = (key, value) => {
    emit('update:filter', { [key]: value });
};
</script>

<style lang="scss" scoped>
.filters-sidebar {
    height: 100%;
}

.filter-card,
.search-card {
    border-radius: 12px;
    border: 1px solid rgba(0, 0, 0, 0.08);
}
</style>
